/**
 * Created by Arif Topcu in 2019
 */

import ComplicationSelector from '@ls/grouping-complication-selector';
import React, {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {setDefinition} from 'state/analytics/actions';
import AnalyticDefinition from 'state/analytics/AnalyticDefinition';
import {selectDefinitions} from 'state/analytics/selectors';
import SelectionState from 'state/selections/SelectionState';
import ComplicationComponent from './AnalyticsSelectorComplication';

const AnalyticsSelector = (props) => {
  const dispatch = useDispatch();
  const definitions = useSelector(selectDefinitions(SelectionState.UNCOMMITTED));
  const setDefinitionCallback = useCallback(
    (idx, definition) => dispatch(setDefinition(idx, definition)),
    [dispatch]
  );
  return (
    <ComplicationSelector
      selectedDefinitions={definitions}
      setDefinition={setDefinitionCallback}
      getDefaultDefinition={AnalyticDefinition.getDefault}
      ComplicationComponent={ComplicationComponent}
      btnTitle="Analytics"
      addMoreText="Analytic Column"
    />
  );
};

export default AnalyticsSelector;
